import type { SVGProps } from 'react';

export function IconKey(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...props}
        >
            <circle cx="7.5" cy="15.5" r="5.5" />
            <path d="M11.4 11.6 21 2" />
            <path d="m15.5 7.5 3 3L22 7l-3-3" />
        </svg>
    );
}
